var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.postData && _vm.postData.length)?_c('section',{staticClass:"home-gallery"},[_c('projectGallery',{attrs:{"data":_vm.postData}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }